// @flow
import React from 'react'
import LiveTooltip from 'live/components/ui/tooltip'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import theme from 'live/services/theme';

export default class OldMnemonicTooltipInfo extends React.Component {

    render() {
        const { data, isWarning } = this.props

        let value = data && data.mnemonic

        return (
                (value && (
                    <LiveTooltip position="top" content={`${i18n('Mnemonic')}: ${value}`}>
                        <StyledIcon isWarning={isWarning} className={`far ${isWarning?'fa-exclamation-triangle':'fa-info-circle'}`} />
                    </LiveTooltip>
                ))|| null
        )
    }

}
const StyledIcon = styled.i`
    margin-top: 8px;
    font-size: 14px;
    color:${({isWarning})=>isWarning?theme['text-warning']:theme['main-tipography']}
`
